/**
 * Created by Colin.Watson on 4/1/2015.
 */
/// <reference path="../../../typings/tsd.d.ts" />
(function () {
	'use strict';
	angular.module('blocks', []);
})();
